import { defineStore } from 'pinia'

// 定义一个用户仓库
export const useUserStore = defineStore('user', {
  // 公共状态：共享数据
  state: () => ({
    username: '',
    token: '',
    isLogin: false
  }),

  // 方法：修改公共数据
  actions: {
    // 登录：保存用户信息
    setUser(info) {
      this.username = info.username
      this.token = info.token
      this.isLogin = true
    },
    // 退出登录：清空数据
    clearUser() {
      this.username = ''
      this.token = ''
      this.isLogin = false
    }
  }
})